// src/utils/getLangCountry.js
import { useParams } from "react-router-dom";

export function useLangCountry() {
  const { lang, country } = useParams();
  return { 
    lang: lang || "en",
    country: country || null
  };
} 